import { DashboardPage } from "@/pages/dashboard";
import { StockItemsPage } from "@/pages/stock-items";
import { StockItemDetailPage } from "@/pages/stock-item-detail";
import { CreateStockItemPage } from "@/pages/create-stock-item";
import { StockMovementsPage } from "@/pages/stock-movements";
import { UnifiedStockMovementPage } from "@/pages/unified-stock-movement";
import { NewStockMovementPage } from "@/pages/new-stock-movement";
import { SalesMovementPage } from "@/pages/sales-movement";
import { PurchaseMovementPage } from "@/pages/purchase-movement";
import { WriteOffMovementPage } from "@/pages/write-off-movement";
import { TransferMovementPage } from "@/pages/transfer-movement";
import { StockTakesPage } from "@/pages/stock-takes";
import { StockTakeCreatePage } from "@/pages/stock-take-create";
import { StockTakesHomePage } from "@/pages/stock-takes-home";
import { StockTakesQuickCountSetupPage } from "@/pages/stock-takes-quick-count-setup";
import { StockTakesQuickCountCountPage } from "@/pages/stock-takes-quick-count-count";
import { StockTakesQuickCountReviewPage } from "@/pages/stock-takes-quick-count-review";
import { StockTakesTargetedCountSetupPage } from "@/pages/stock-takes-targeted-count-setup";
import { StockTakesFullSetupPage } from "@/pages/stock-takes-full-setup";
import { StockTakesFullCountPage } from "@/pages/stock-takes-full-count";
import { StockTakesFullReviewPage } from "@/pages/stock-takes-full-review";
import { StockTakesPartialSetupPage as StockTakesTargetedSetupPage } from "@/pages/stock-takes-partial-setup";
import { StockTakesPartialCountPage as StockTakesTargetedCountPage } from "@/pages/stock-takes-partial-count";
import { StockTakesPartialReviewPage as StockTakesTargetedReviewPage } from "@/pages/stock-takes-partial-review";
import { StockTakesCycleCountSetupPage } from "@/pages/stock-takes-cycle-count-setup";
import { StockTakesCycleCountCountPage } from "@/pages/stock-takes-cycle-count-count";
import { StockTakesCycleCountReviewPage } from "@/pages/stock-takes-cycle-count-review";
import { LotBatchSerialPage } from "@/pages/lot-batch-serial";
import { PurchaseOrdersPage } from "@/pages/purchase-orders";
import { ReceiveGoodsPage } from "@/pages/receive-goods";
import { SuppliersPage } from "@/pages/suppliers";
import { CustomersPage } from "@/pages/customers";
import { SalesOrdersPage } from "@/pages/sales-orders";
import { PickPackPage } from "@/pages/pick-pack";
import ShippingPage from "@/pages/shipping";
import { ProjectsCostCentersPage } from "@/pages/projects-cost-centers";
import { AssemblyPage } from "@/pages/assembly";
import { BillsOfMaterialPage } from "@/pages/bills-of-material";
import { CreateBOMPage } from "@/pages/create-bom";
import { WorkOrdersPage } from "@/pages/work-orders";
import { CreateWorkOrderPage } from "@/pages/create-work-order";
import { PriceMatrixPage } from "@/pages/price-matrix";
import { MarginAnalysisPage } from "@/pages/margin-analysis";
import { CostAnalysisPage } from "@/pages/cost-analysis";
import DemandForecastingPage from "@/pages/demand-forecasting";
import ReorderRecommendationsPage from "@/pages/reorder-recommendations";
import { ReportsPage } from "@/pages/reports";
import { IntegrationSetupPage } from "@/pages/integration-setup";
import { SyncStatusPage } from "@/pages/sync-status";
import { StockOptionsPage } from "@/pages/stock-options";
import FeatureFlagsSettings from "@/pages/feature-flags-settings";
import { WarehousesLocationsPage } from "@/pages/warehouses-locations";
import { UserProfilesPage } from "@/pages/user-profiles";
import { UsersPage } from "@/pages/users";
import { PermissionsDemo } from "@/pages/permissions-demo";
import { CompanyDetailsPage } from "@/pages/company-details";
import { CustomFieldsPage } from "@/pages/custom-fields";
import { FIFODemoPage } from "@/pages/fifo-demo";
import { PlaceholderPage } from "@/pages/placeholder-page";
import TaxRatesPage from "@/pages/tax-rates";
import ABCClassificationPage from "@/pages/abc-classification";
import { HelpSystemDemoPage } from "@/pages/help-system-demo";
// New placeholder pages
import { GoodsInOutPage } from "@/pages/goods-in-out";
import { StockAssistantPage } from "@/pages/stock-assistant";
import { QuickStartPage } from "@/pages/quick-start";
import { NonStockItemsPage } from "@/pages/non-stock-items";
import { AdvancedPricingPage } from "@/pages/advanced-pricing";
// Stock Transfers
import { StockTransfersPage } from "@/pages/stock-transfers";
import { StockTransfersStep1Page } from "@/pages/stock-transfers-step1";
import { StockTransfersStep2Page } from "@/pages/stock-transfers-step2";
import { StockTransfersStep3Page } from "@/pages/stock-transfers-step3";
// New consolidated pages
// SystemConfigurationPage removed - using stock-options page instead
import { IntegrationSyncPage } from "@/pages/integration-sync";
import { CompanySettingsPage } from "@/pages/company-settings";
import { UserManagementPage } from "@/pages/user-management";
import { WarehouseLocationSetupPage } from "@/pages/warehouse-location-setup";

interface PageRouterProps {
  activePage: string;
  pageParams?: Record<string, any>;
}

export function PageRouter({ activePage, pageParams = {} }: PageRouterProps) {
  switch (activePage) {
    case "dashboard":
      return <DashboardPage />;
    case "stock-items":
      return <StockItemsPage />;
    case "stock-item-detail":
      return <StockItemDetailPage pageParams={pageParams} />;
    case "create-stock-item":
      return <CreateStockItemPage />;
    case "stock-movements":
      return <StockMovementsPage />;
    case "new-stock-movement":
      return <NewStockMovementPage />;
    case "add-movement":
      return <UnifiedStockMovementPage />;
    case "sales-movement":
      return <SalesMovementPage />;
    case "purchase-movement":
      return <PurchaseMovementPage />;
    case "write-off-movement":
      return <WriteOffMovementPage />;
    case "transfer-movement":
      return <TransferMovementPage />;
    case "stock-takes":
      return <StockTakesPage pageParams={pageParams} />;
    case "stock-takes-home":
      return <StockTakesHomePage />;
    case "stock-takes/quick-count/setup":
      return <StockTakesQuickCountSetupPage />;
    case "stock-takes/quick-count/count":
      return <StockTakesQuickCountCountPage formData={pageParams.formData} />;
    case "stock-takes/quick-count/review":
      return <StockTakesQuickCountReviewPage setupData={pageParams.setupData} countedItems={pageParams.countedItems} />;
    case "stock-takes/targeted-count/setup":
      return <StockTakesTargetedCountSetupPage />;
    case "stock-takes/full/setup":
      return <StockTakesFullSetupPage />;
    case "stock-takes/full/count":
      return <StockTakesFullCountPage setupData={pageParams.setupData} />;
    case "stock-takes/full/review":
      return <StockTakesFullReviewPage setupData={pageParams.setupData} countedItems={pageParams.countedItems} />;
    case "stock-takes/targeted/setup":
      return <StockTakesTargetedSetupPage pageParams={pageParams} />;
    case "stock-takes/targeted/count":
      return <StockTakesTargetedCountPage setupData={pageParams.setupData} />;
    case "stock-takes/targeted/review":
      return <StockTakesTargetedReviewPage setupData={pageParams.setupData} countedItems={pageParams.countedItems} />;
    case "stock-takes/cycle-count/setup":
      return <StockTakesCycleCountSetupPage />;
    case "stock-takes/cycle-count/count":
      return <StockTakesCycleCountCountPage setupData={pageParams.setupData} />;
    case "stock-takes/cycle-count/review":
      return <StockTakesCycleCountReviewPage setupData={pageParams.setupData} countedItems={pageParams.countedItems} />;
    case "create-stock-take":
      return <StockTakeCreatePage stockTakeId={pageParams.stockTakeId} />;
    case "assembly":
      return <AssemblyPage />;
    case "price-matrix":
      return <PriceMatrixPage />;
    case "margin-analysis":
      return <MarginAnalysisPage />;
    case "cost-analysis":
      return <CostAnalysisPage />;
    case "ai-forecasting":
      return <DemandForecastingPage />;
    case "reports":
      return <ReportsPage />;
    // New consolidated pages
    // system-configuration now uses stock-options page
    case "integration-sync":
      return <IntegrationSyncPage />;
    case "company-settings":
      return <CompanySettingsPage />;
    case "user-management":
      return <UserManagementPage />;
    
    // Legacy pages (kept for backward compatibility)
    case "integration-setup":
      return <IntegrationSetupPage />;
    case "sync-status":
      return <SyncStatusPage />;
    case "stock-options":
      return <StockOptionsPage />;
    case "feature-flags":
      return <FeatureFlagsSettings />;
    case "warehouses-locations":
      return <WarehousesLocationsPage />;
    case "user-profiles":
      return <UserProfilesPage />;
    case "users":
      return <UsersPage />;
    case "company-details":
      return <CompanyDetailsPage />;
    case "custom-fields":
      return <CustomFieldsPage />;
    case "tax-rates":
      return <TaxRatesPage />;
    
    // Inventory submenu
    case "warehouses":
      return <WarehousesLocationsPage />;
    case "warehouse-location-setup":
      return <WarehouseLocationSetupPage />;
    case "tracking":
      return <LotBatchSerialPage />;
    
    // Stock Transfers
    case "stock-transfers":
      return <StockTransfersPage />;
    case "stock-transfers/create/step1":
      return <StockTransfersStep1Page pageParams={pageParams} />;
    case "stock-transfers/create/step2":
      return <StockTransfersStep2Page pageParams={pageParams} />;
    case "stock-transfers/create/step3":
      return <StockTransfersStep3Page pageParams={pageParams} />;
    
    // Purchasing submenu
    case "purchase-orders":
      return <PurchaseOrdersPage />;
    case "receive-goods":
      return <ReceiveGoodsPage pageParams={pageParams} />;
    case "suppliers":
      return <SuppliersPage />;
    
    // Sales & Fulfillment submenu
    case "sales-orders":
      return <SalesOrdersPage />;
    case "pick-pack":
      return <PickPackPage pageParams={pageParams} />;
    case "shipping":
      return <ShippingPage />;
    case "customers":
      return <CustomersPage />;
    
    // Master Data
    case "projects-cost-centers":
      return <ProjectsCostCentersPage />;
    
    // Manufacturing submenu
    case "boms":
      return <BillsOfMaterialPage />;
    case "bills-of-material":
      return <BillsOfMaterialPage />;
    case "create-bom":
      return <CreateBOMPage />;
    case "work-orders":
      return <WorkOrdersPage />;
    case "create-work-order":
      return <CreateWorkOrderPage />;
    case "production-schedule":
      return <PlaceholderPage title="Production Schedule" />;
    case "routing":
      return <PlaceholderPage title="Routings & Work Centers" />;
    
    // AI Forecasting & Analytics submenu
    case "abc-classification":
      return <ABCClassificationPage />;
    case "reorder":
      return <ReorderRecommendationsPage />;
    
    // Permissions Demo
    case "permissions-demo":
      return <PermissionsDemo />;
    
    // FIFO Demo
    case "fifo-demo":
      return <FIFODemoPage />;
    
    // Help System Demo
    case "help-system-demo":
      return <HelpSystemDemoPage />;
    
    // New placeholder pages
    case "goods-in-out":
      return <GoodsInOutPage />;
    case "stock-assistant":
      return <StockAssistantPage />;
    case "quick-start":
      return <QuickStartPage />;
    case "non-stock-items":
      return <NonStockItemsPage />;
    case "advanced-pricing":
      return <AdvancedPricingPage />;
    
    default:
      return <DashboardPage />;
  }
}
